<template>
    <div
        class="c-a-input req-secure-jobs"
        :class="{ 'c-a-input--invalid': invalid }"
    >
        <modal
            class="c-m-modal--small c-m-modal--image"
            v-if="showModal"
            @close="showModal = false"
        >
            <div>
                <ul class="u-margin-bottom-6">
                    <li>
                        Med TryggtJobb hjälper vi dig att få ett komplett avtal
                        signerat av hantverkaren.
                    </li>
                    <li>
                        Vi använder bara avtalsmallar framtagna av
                        Konsumentverket, Villaägarna och Sveriges
                        Byggindustrier. Allt för att säkerställa din trygghet!
                    </li>
                    <li>TryggtJobb är gratis för dig som beställare.</li>
                </ul>
                <AtomButton
                    :label="'Jag vill inte ha TryggtJobb'"
                    :modifiers="'SecJo-DeclineButton'"
                    @buttonClicked="Decline"
                ></AtomButton>
                <AtomButton
                    :label="'Jag vill ha TryggtJobb'"
                    @buttonClicked="Accept"
                ></AtomButton>
            </div>
        </modal>

        <div class="c-a-checkbox" :class="{ 'c-a-checkbox--invalid': invalid }">
            <input
                class="c-a-checkbox__input"
                type="checkbox"
                :name="`checkbox-${id}`"
                :id="`checkbox-${id}`"
                value="1"
                v-model="selected"
                v-on:change="updated"
            />
            <label class="c-a-checkbox__label" :for="`checkbox-${id}`">
                <span class="c-a-checkbox__box">
                    <icon :icon="'check'" />
                </span>
                <span class="c-a-checkbox__text" v-html="labelActual"></span>
            </label>
        </div>
        <h3>Därför ska du använda TryggtJobb:</h3>
        <div class="req-secure-jobs-container">
            <div class="req-secure-jobs-column">
                <ul>
                    <li>
                        Möjlighet att signera hantverkaravtal digitalt.
                    </li>
                    <li>
                        Matchning mot kvalitetskontrollerade hantverk.
                    </li>
                    <li>
                        TryggtJobb är kostnadsfritt.
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../AtomIcon.vue";
import AtomButton from "../AtomButton";
import modal from "../../molecules/MoleculeModal";

export default {
    components: {
        Icon,
        modal,
        AtomButton
    },
    props: {
        icon: String,
        id: Number,
        label: String,
        question: String,
        invalid: Boolean,
        required: Boolean,
        dataKey: String,
        // ifall man vill ha en föribockad checkbox kan detta användas
        checked: Boolean
    },
    data() {
        return {
            selected: this.checked,
            showModal: false
        };
    },
    computed: {
        labelActual: function() {
            return this.required ? `${this.label} *` : this.label;
        }
    },
    methods: {
        updated() {
            const data = {
                questionId: this.id,
                label: this.label,
                answers: this.selected ? true : false,
                single: true
            };

            if (!this.selected) {
                this.showModal = true;
            }

            if (this.dataKey) {
                data.dataKey = this.dataKey;
            }

            this.$emit("updateData", data);
        },
        Accept() {
            this.selected = true;
            this.updated();
            this.showModal = false;
        },
        Decline() {
            this.showModal = false;
        }
    },
    mounted() {
        // om proppen 'checked' är true ska formen uppdateras automatiskt ifall värdet inte ändras av användaren
        if (this.checked) {
            this.updated();
        }
    }
};
</script>
<style scoped>
.req-secure-jobs {
    background: #fff7ec;
    border: 1px solid rgba(220, 135, 49, 0.5);
    box-sizing: border-box;
    border-radius: 8px;
    padding: 1rem;
}
.SecJo-DeclineButton {
    background: #005178;
    color: #ffff;
}
.req-secure-jobs-container {
    display: flex;
}

.req-secure-jobs-column span {
    font-weight: bold;
}

@media (max-width: 480px) {
    .req-secure-jobs-container {
        flex-direction: column;
    }
}
@media (max-width: 600px) {
    .SecJo-DeclineButton {
        margin-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomSecureJobsRequestForm.vue